import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController, LoadingController } from 'ionic-angular';
import { Http } from '@angular/http';

import config from '../../config/config';

import { LoginPage } from '../login/login';

/**
 * Generated class for the RecadastramentoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-recadastramento',
  templateUrl: 'recadastramento.html',
})
export class RecadastramentoPage {
	form={};

  constructor(
  	public navCtrl: NavController,
  	private _http : Http,
   	private alertCtrl: AlertController,
   	public loadingCtrl: LoadingController,
  	public navParams: NavParams) {}

voltarLogin(){
    this.navCtrl.setRoot(LoginPage);
}
cadastrar(form){
	if(form.email && form.cpf){
	let loading = this.loadingCtrl.create({
    content: 'Recadastrando.'
  });
	loading.present();
	this._http
        .post(config.urlAPI+"recadastro",form,{})
        .map(res => res.json())
        .toPromise()
        .then(res => {
			loading.dismiss();
			if (res) {
				let alert = this.alertCtrl.create({
					title: 'Sucesso!',
					message: 'Sua nova senha foi enviada para o e-mail indicado',
					buttons:[{
							  text: 'Ok',
							  handler: data => {
								this.navCtrl.push(LoginPage);
							  }
							}]
				  });
				  alert.present();
	
				
			}else{
				let alert = this.alertCtrl.create({
					title: 'CPF!',
					message: 'O CPF indicado não foi encontrado',
					buttons:[{
							  text: 'Ok',
							  handler: data => {
							  }
							}]
				  });
				  alert.present();
			}
			console.log(res);
		
        }).catch(error => {
          console.log(error);          
        });
	}else{
		let alert = this.alertCtrl.create({
			title: 'OPS!',
			message: 'Somente com o preenchimento completo poderemos lhe enviar a senha',
			buttons:[{
					  text: 'Ok',
					  handler: data => {
					  }
					}]
		  });
		  alert.present();
	}
}

}



// WEBPACK FOOTER //
// ./src/pages/recadastramento/recadastramento.ts